import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { RouterOutlet } from '@angular/router';
import { SideMenuComponent } from '@shared/components/side-menu/side-menu.component';
import { HeaderComponent } from '@shared/components/header/header.component';

@Component({
  selector: 'emp-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [HeaderComponent, RouterOutlet, SideMenuComponent, ScrollingModule]
})
export class MainLayoutComponent {}
